<template>
  <div class='demo-app'>
    <div class="col-md-12 px-0">
      <div class="d-flex flex-wrap align-items-center justify-content-sm-center justify-content-md-between">
        <el-button @click="openModal('help')">Como agendar seu Trading System</el-button>
        <br />
        <el-button  style="color: black; cursor: unset;">Tentativas restantes: {{credits}}</el-button >
      </div>
      <card class="card-calendar" :class="'card-'+theme">
        <div>
          <FullCalendar
            class='demo-app-calendar text-left overflow-auto'
            ref="fullCalendar"
            defaultView="dayGridMonth"
            :header="{
              left: 'title',
              center: '',
              right: 'prev,next'
            }"
            :plugins="calendarPlugins"
            :weekends="calendarWeekends"
            :events="events"
            locale="pt-br"
            themeSystem="bootstrap"
            @eventClick="clickEvent"
            />
        </div>
      </card>
    </div>
    <!-- if reservedConfirm -->
    <div class="col-md-12">
      <div class="d-flex justify-content-center">
        <div class="row overflow-auto">
          <card class="table" v-if="this.reserved" :class="'card-'+theme">
            <p class="separador">
              Atualize a página ao se aproximar da hora marcada para visualizar a mudança do status do agendamento.
            </p>
            <div>
              <thead>
                <tr>
                  <th scope="col">Dia</th>
                  <th scope="col">Início</th>
                  <th scope="col">Fim</th>
                  <th scope="col">Url</th>
                  <th scope="col">Ação</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="reserve in reserves" :key="reserve.id">
                  <th>{{reserve.date | moment("DD/MM/YYYY")}}</th>
                  <td>{{[reserve.time_initial, "HH:mm:ss"] | moment("HH:mm")}}</td>
                  <td>{{[reserve.time_final, "HH:mm:ss"] | moment("HH:mm")}}</td>
                  <td>
                    <button
                      v-if="reserve.status == 'awaiting' && reserve.url_hangouts"
                      class="btn btn-fill btn-success"
                    >
                      <a :href="reserve.url_hangouts" target="_blank">
                        <i class="nc-icon nc-tap-01"></i> Iniciar TS
                      </a>
                    </button>
                  </td>
                  <td>
                    <button
                      v-if="reserve.status == 'reserved' && !reserve.url_hangouts"
                      class="btn btn-warning"
                      @click="cancelTS(reserve.available_time_id, reserve.id, reserve.time_initial, reserve.date )"
                    >Cancelar</button>
                  </td>
                  <td>
                    <b v-if="reserve.status == 'reserved'" style="color: #1f77d0">Aguardando</b>
                    <b v-if="reserve.status == 'awaiting'" style="color: #1f77d0">Em andamento</b>
                    <b v-if="reserve.status == 'is_done'" style="color: green">Concluido</b>
                    <b
                      v-if="reserve.status == 'teacher_missed'"
                      style="color: red"
                    >Cancelado pelo Professor</b>
                    <b v-if="reserve.status == 'student_cancel'" style="color: red">Cancelado pelo Aluno</b>
                    <b v-if="reserve.status == 'student_missed'" style="color: red">Aluno Ausente</b>
                    <b v-if="reserve.status == 'other'" style="color: red">Cancelado por outros motivos</b>
                  </td>
                </tr>
              </tbody>
            </div>
          </card>
        </div>
      </div>
    </div>
    <el-dialog center title="Agendamento de Trading System" :visible.sync="modals.markTS">
      <div class="col-md-12">
        <form class="text-center col-md-12" @submit.prevent="submitNewTS()" method="post">
          <div>
            <el-select
              class="select-primary col-md-8"
              size="large"
              placeholder="Veja os horários disponíveis"
              v-model="hourSelected.hour"
              required
            >
              <el-option
                v-for="timeMark in selectedDay"
                :key="timeMark.title"
                :label="'De ' + timeMark.title + ' às ' + timeMark.end "
                :value="timeMark.title"
                :bind="hourSelected.date = timeMark.start"
              ></el-option>
            </el-select>
            <br />
            <br />
            <div>
              <button class="btn btn-primary btn-fill btn-md" type="submit">
                <i class="nc-icon nc-send"></i> Marcar
              </button>
            </div>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </el-dialog>
    <el-dialog center title="Como agendar seu Trading System" :visible.sync="modals.help">
      <div>
        <iframe src="https://player.vimeo.com/video/421283551" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
      <br />
      <p
        style="white-space: pre-wrap; word-break: keep-all;"
      >Para agendar um horário de Trading System certifique-se da sua disponilidade e clique sobre a hora desejada.</p>
      <p
        style="white-space: pre-wrap; word-break: keep-all;"
      >O cancelamento é gratuito (seus créditos serão restituidos) até 1 hora antes do horário marcado, após esse horário não será possível a restituição. Caso o cancelamento seja por parte do professor, seu crédito também será restituido.
      </p>
    </el-dialog>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrap from '@fullcalendar/bootstrap'
import swal from "sweetalert2"
import moment from "moment"
import _ from "lodash"
import {
  Loading,
  Table,
  TableColumn,
  Dialog,
  Select,
  Option
} from "element-ui";
import { log } from 'fullcalendar'

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data: function() {
    return {
      modals: {
        markTS: false,
        cancel: false,
        evaluation: false,
        help: false
      },
      loadingTimes: false,
      loadingEvaluation: false,
      timeNow: moment(),
      events: [],
      allEventsWithIds: [],
      eventsUniq: [{}],
      selectedDay: [],
      reserves: [],
      calendar: {},
      actualTS: false,
      afterTS: false,
      reserved: false,
      credits: "",
      /* evaluationTS: {
        evaluation: "",
        student_comment: "",
        id: ""
      }, */
      times: [{}],
      daySelected: {
        available_time_id: ""
      },
      hourSelected: {
        hour: "",
        date: ""
      },
      dayCancel: {
        available_time_id: "",
        id: ""
      },
      calendarPlugins: [ // plugins must be defined in the JS
        bootstrap,
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin // needed for dateClick
      ],
      calendarWeekends: false,
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created() {
    this.fetchAllTimesAvaliable();
    this.getStudentReserves();
    this.getStudentCredits();
  },
  methods: {
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    fetchAllTimesAvaliable() {
      this.loadingTimes = true;
      this.axios
        .get("/times")
        .then(response => {
          this.loadingTimes = false
          this.times = response.data.available_times
          let allEvents = this.times.map(allObj => {
            return {
              title: moment(allObj.time_initial, "HH:mm:ss").format("HH:mm"),
              start: allObj.date,
              end: moment(allObj.time_final, "HH:mm:ss").format("HH:mm"),
              backgroundColor: "#3075d491"
            }
          })
          this.events = _.uniqWith(allEvents, _.isEqual)
        })
        .catch(error => {
          this.loadingTimes = false;
          console.log(error)
        });
    },
    getStudentReserves() {
      this.axios
        .get("/reserves")
        .then(response => {
          this.reserves = response.data.available_times;

          if (this.reserves === undefined || this.reserves.length === "0") {
            this.openModal('help')
            this.reserved = false
          } else {
            this.reserved = true
          }
          /* let tsDone = _.filter(this.reserves, function(o) {
            return (
              o.status == "is_done" &&
              o.student_comment == null &&
              o.evaluation == null
            );
          });
          if (tsDone != "") {
            this.evaluationTS.id = tsDone[0].id
            this.modals["evaluation"] = true
          } */
        })
        .catch(error => {
          this.loadingReserves = false
          console.log(error)
        });
    },
    getStudentCredits() {
      this.axios
        .get("/credits")
        .then(response => {
          this.credits = response.data.student_credits[0].value;
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitNewTS() {
      this.axios
        .post("/reserves", this.hourSelected)
        .then(response => {
          this.fetchAllTimesAvaliable();
          this.getStudentReserves();
          this.getStudentCredits();
          swal({
            title: `Trading System Marcado com Sucesso!`,
            text:
              "Fique atento, o professor irá disponibilizar o link para contato até 10 minutos antes do horário marcado. Caso precise desmarcar, cancele com até 1 hora de antecendência.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success"
          });
          this.closeModal("markTS");
        })
        .catch(error => {
          console.log(error);
          alert(
            "Erro ao marcar seu horário de Trading System. Tente novamente. \n" +
              error
          );
        });
    },
    cancelTS(available_time_id, id, time_initial, date) {
      this.dayCancel.id = id; //for update student_reserves
      this.dayCancel.available_time_id = available_time_id; //for update available_times
      let oneHourBefore = time_initial;
      let dateTS = date;
      let self = this;

      swal({
        title: "Tem certeza que deseja cancelar o seu Trading System?",
        text: `O cancelamento só será aceito até 1 hora antes do horário marcado`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-danger btn-fill",
        cancelButtonClass: "btn  btn-success btn-fill",
        confirmButtonText: "Sim, remarcarei em outro momento",
        cancelButtonText: "Não, quero seguir com o cronograma!",
        buttonsStyling: false
      }).then(function(result) {
        if (
          self.timeNow.isBefore(dateTS, "day") ||
          (self.timeNow.isSame(dateTS, "day") &&
            self.timeNow.add(1, "h").format("HH:mm") <= oneHourBefore)
        ) {
          if (result.value) {
            swal({
              title: "Cancelado!",
              text:
                "Tudo bem, imprevistos acontecem =/. Assim que puder faça novamente o agendamento.",
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
            self.axios
              .patch("/reserves", self.dayCancel)
              .then(response => {
                self.fetchAllTimesAvaliable();
                self.getStudentReserves();
                self.getStudentCredits();
              })
              .catch(error => {
                console.log(error);
                alert(
                  "Erro ao marcar atualizar no caminho '/reserves'. Entre em contato com o setor de TI. \n" +
                    error
                );
              })
          } else {
            swal({
              title: "Tudo certo, te aguardamos no horário marcado",
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          }
        } else {
          swal({
            title: "Não foi possivel cancelar o agendamento",
            text:
              "O tempo de cancelamento é até 1 hora antes do horário agendado",
            type: "error",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    clickEvent (event) {
      let test = moment(event.event.start).format("YYYY-MM-DD")

      this.selectedDay = _.filter(this.events, function(o) {
        return o.start == test
      })

      this.openModal("markTS");

      let leastOneReserve = _.filter(this.reserves, function(o) {
        return o.status == "awaiting" || o.status == "reserved";
      });

      if (leastOneReserve.length) {
        this.closeModal("markTS");
        swal({
          title: `Você ja tem um Trading System Marcado`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success btn-fill",
          type: "error"
        });
      }
      if (this.credits == 0) {
        this.closeModal("markTS");
        swal({
          title: "Você não tem Creditos suficientes",
          type: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      }
    }
  }
}

</script>

<style lang='scss'>

// you must include each plugins' css
// paths prefixed with ~ signify node_modules
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
@import '~@fullcalendar/bootstrap/main.css';

.demo-app {
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}

.demo-app-calendar {
  margin: 0 auto;
  max-width: 900px;
}
.separador::after {
  content: "";
  background-color: #ffa534;
  height: 2px;
  width: 58px;
  display: block;
}
#fullCalendar {
  min-height: 300px;
}

.fc th {
  text-align: center !important;
}
/* .fc-day-grid-event {
  color: black !important;
} */

.fc button {
  border-color: #ffffff !important;
  background-color: #4091ff !important;
  color: #ffffff !important;
}

.fc-popover {
  border-color: #4091ff !important;
  background-color: #4091ff !important;
  color: #ffffff !important;
}
.fc-popover {
  border-color: #4091ff !important;
  background-color: #85a8d6 !important;
  color: #ffffff !important;
}

.alert {
  background: #3075d491 !important;
  color: #ffffff !important;
}
.el-loading-spinner .path {
  stroke: #66615b !important;
}
.el-button {
  padding: 15px 15px 10px 15px !important;
  width: 250px !important;
  height: 50px !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Calendar/OtherFullCalendar.vue